import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { track } from '@amplitude/analytics-browser'
import { collectionShowcaseAction } from 'src/reducers/collection/action'
import useCourseCreation from 'src/hooks/useCourseCreation'
import { ACTION_TYPES } from '../constants'

const callIntercom = (...args) => {
  if (window.Intercom) {
    window.Intercom(...args)
  }
}

const safeTrack = (event, props) => {
  try {
    track(event, props)
  } catch (error) {
    console.error('Error tracking event:', error)
  }
}

/**
 * Runs the declarative actions defined in `constants`.
 *
 * Tracking: items with a `track` config send that (legacy) event with
 * `source: 'knowledge_base'`; launch and suggested items send
 * `clicked_home_item` with `{ section, item_id }`.
 */
const useHomeAction = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    startCourseCreation,
    limitModalOpen,
    closeLimitModal,
  } = useCourseCreation()

  const runAction = (action, { section, itemId, track: tracking } = {}) => {
    if (tracking) {
      safeTrack(tracking.event, { source: 'knowledge_base', ...tracking.props })
    } else if (section) {
      safeTrack('clicked_home_item', {
        source: 'home',
        section,
        item_id: itemId,
      })
    }

    switch (action.type) {
      case ACTION_TYPES.ROUTE:
        history.push(action.to)
        break
      case ACTION_TYPES.CREATE_COURSE:
        if (startCourseCreation()) {
          safeTrack('clicked_create_course', {
            type: 'independent',
            source: 'home_section',
          })
        }
        break
      case ACTION_TYPES.OPEN_PORTAL:
        // The portal is the workspace showcase collection.
        dispatch(
          collectionShowcaseAction({}, response => {
            history.push(`/collection/${response.id}/landing-page`)
          }),
        )
        break
      case ACTION_TYPES.EXTERNAL:
        window.open(action.href, '_blank', 'noopener,noreferrer')
        break
      case ACTION_TYPES.INTERCOM_ARTICLE:
        callIntercom('showArticle', action.articleId)
        break
      case ACTION_TYPES.INTERCOM_SPACE:
        callIntercom('showSpace', action.space)
        break
      case ACTION_TYPES.INTERCOM_MESSAGES:
        callIntercom('showMessages')
        break
      default:
        break
    }
  }

  return { runAction, limitModalOpen, closeLimitModal }
}

export default useHomeAction
